import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, createBlock as _createBlock, mergeProps as _mergeProps, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/menu/1.jpg'
import _imports_1 from '@/assets/img/menu/2.jpg'
import _imports_2 from '@/assets/img/menu/3.jpg'
import _imports_3 from '@/assets/img/menu/4.jpg'
import _imports_4 from '@/assets/img/menu/5.jpg'
import _imports_5 from '@/assets/img/bg/price_bg.jpg'
import _imports_6 from '@/assets/img/flow/2.jpg'
import _imports_7 from '@/assets/img/flow/3.jpg'
import _imports_8 from '@/assets/img/flow/4.jpg'
import _imports_9 from '@/assets/img/flow/5.jpg'
import _imports_10 from '@/assets/img/flow/6.jpg'
import _imports_11 from '@/assets/img/trainers/1.jpg'
import _imports_12 from '@/assets/img/trainers/2.jpg'
import _imports_13 from '@/assets/img/sns/twitter.png'
import _imports_14 from '@/assets/img/sns/Instagram.png'
import _imports_15 from '@/assets/img/logo/logo_simple.png'


const _hoisted_1 = {
  ref: "root",
  class: "call topPage"
}
const _hoisted_2 = { class: "slider-outer" }
const _hoisted_3 = { class: "slider-inner sp-none" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "slider-text slider-text1"
}
const _hoisted_6 = {
  key: 1,
  class: "slider-text slider-text2"
}
const _hoisted_7 = {
  key: 2,
  class: "slider-text slider-text3"
}
const _hoisted_8 = {
  key: 3,
  class: "slider-text slider-text4"
}
const _hoisted_9 = { class: "slider-inner pc-none" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "slider-text slider-text1"
}
const _hoisted_12 = {
  key: 1,
  class: "slider-text slider-text2"
}
const _hoisted_13 = {
  key: 2,
  class: "slider-text slider-text3"
}
const _hoisted_14 = {
  key: 3,
  class: "slider-text slider-text4"
}
const _hoisted_15 = { class: "top-content" }
const _hoisted_16 = { class: "top-content-head top-content-primary" }
const _hoisted_17 = {
  id: "news",
  class: "news fade-in"
}
const _hoisted_18 = { class: "news-list" }
const _hoisted_19 = { class: "news-list-date" }
const _hoisted_20 = { class: "news-list-title" }
const _hoisted_21 = { class: "news-button-wrap" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = {
  id: "lesson",
  class: "lesson fade-in"
}
const _hoisted_24 = { class: "top-items-title" }
const _hoisted_25 = { class: "lesson-schedule-note" }
const _hoisted_26 = { class: "checkbox-list" }
const _hoisted_27 = { class: "lesson-schedulebox-wrap" }
const _hoisted_28 = { class: "lesson-schedulebox" }
const _hoisted_29 = {
  key: 0,
  class: "monday"
}
const _hoisted_30 = {
  key: 1,
  class: "tuesday"
}
const _hoisted_31 = {
  key: 2,
  class: "wednesday"
}
const _hoisted_32 = {
  key: 3,
  class: "thursday"
}
const _hoisted_33 = {
  key: 4,
  class: "friday"
}
const _hoisted_34 = {
  key: 5,
  class: "saturday"
}
const _hoisted_35 = {
  key: 6,
  class: "sunday"
}
const _hoisted_36 = { class: "top-content-head top-content-primary" }
const _hoisted_37 = { class: "price-button fade-in" }
const _hoisted_38 = { class: "button-wrap" }
const _hoisted_39 = { class: "button" }
const _hoisted_40 = {
  id: "price",
  class: "price"
}
const _hoisted_41 = { class: "fade-in" }
const _hoisted_42 = { class: "price-cam" }
const _hoisted_43 = { class: "price-cam-item-wrap" }
const _hoisted_44 = { class: "price-cam-item" }
const _hoisted_45 = { class: "button-wrap" }
const _hoisted_46 = { class: "button" }
const _hoisted_47 = { class: "price-cam-item" }
const _hoisted_48 = { class: "button-wrap" }
const _hoisted_49 = { class: "button" }
const _hoisted_50 = { class: "price-cam-item-wrap2" }
const _hoisted_51 = { class: "price-cam-item" }
const _hoisted_52 = { class: "button-wrap" }
const _hoisted_53 = { class: "button" }
const _hoisted_54 = { class: "price-cam-item-wrap2" }
const _hoisted_55 = { class: "price-cam-item" }
const _hoisted_56 = { class: "button-wrap" }
const _hoisted_57 = { class: "button" }
const _hoisted_58 = {
  id: "price-list",
  class: "price-list-sub fade-in"
}
const _hoisted_59 = { class: "top-items-title" }
const _hoisted_60 = { class: "checkbox-list" }
const _hoisted_61 = { class: "price-list-wrap fade-in" }
const _hoisted_62 = { class: "price-list" }
const _hoisted_63 = { class: "price-list-item" }
const _hoisted_64 = {
  key: 0,
  class: "price-list-des"
}
const _hoisted_65 = {
  key: 1,
  class: "price-list-des"
}
const _hoisted_66 = {
  key: 0,
  class: "price-list-item"
}
const _hoisted_67 = { class: "price-list-des" }
const _hoisted_68 = { class: "price-list-des-grid" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { key: 2 }
const _hoisted_71 = { class: "price-list-des-grid" }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 2 }
const _hoisted_74 = {
  key: 1,
  class: "price-list-item"
}
const _hoisted_75 = { class: "price-list-des" }
const _hoisted_76 = { class: "price-list-des-grid" }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { key: 2 }
const _hoisted_79 = { class: "price-list-des-grid" }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { class: "price-list-item" }
const _hoisted_83 = { class: "price-list-des" }
const _hoisted_84 = { class: "price-list-des-grid" }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = { key: 3 }
const _hoisted_88 = { class: "price-list-des-grid" }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 2 }
const _hoisted_91 = { key: 3 }
const _hoisted_92 = {
  key: 2,
  class: "price-list-item"
}
const _hoisted_93 = { class: "price-list-des" }
const _hoisted_94 = {
  key: 0,
  class: "price-list-des-grid2"
}
const _hoisted_95 = {
  key: 1,
  class: "price-list-des-grid2"
}
const _hoisted_96 = {
  key: 2,
  class: "price-list-des-grid2"
}
const _hoisted_97 = {
  key: 3,
  class: "price-list-item"
}
const _hoisted_98 = { class: "price-list-des" }
const _hoisted_99 = { class: "price-list-des-grid" }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { key: 2 }
const _hoisted_102 = { class: "price-list-des-grid" }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { key: 2 }
const _hoisted_105 = {
  key: 4,
  class: "price-list-item"
}
const _hoisted_106 = { class: "price-list-item" }
const _hoisted_107 = { class: "price-list-des" }
const _hoisted_108 = { class: "price-list-des" }
const _hoisted_109 = {
  key: 0,
  class: "price-list-des-grid2"
}
const _hoisted_110 = {
  key: 1,
  class: "price-list-des-grid2"
}
const _hoisted_111 = { class: "price-button fade-in" }
const _hoisted_112 = { class: "button-wrap" }
const _hoisted_113 = { class: "button" }
const _hoisted_114 = { class: "price-button fade-in" }
const _hoisted_115 = { class: "button-wrap" }
const _hoisted_116 = { class: "button" }
const _hoisted_117 = {
  id: "qa",
  class: "qa fade-in"
}
const _hoisted_118 = { class: "qa-list" }
const _hoisted_119 = { class: "qa-list-item" }
const _hoisted_120 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_121 = { class: "qa-list-text" }
const _hoisted_122 = { class: "qa-list-item" }
const _hoisted_123 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_124 = { class: "qa-list-item" }
const _hoisted_125 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_126 = { class: "qa-list-item" }
const _hoisted_127 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_128 = { class: "qa-list-item" }
const _hoisted_129 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_130 = { class: "qa-list-item" }
const _hoisted_131 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_132 = { class: "qa-list-item" }
const _hoisted_133 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_134 = {
  id: "staff",
  class: "staff fade-in"
}
const _hoisted_135 = { class: "member-wrap" }
const _hoisted_136 = { class: "fade-in" }
const _hoisted_137 = { class: "fade-in" }
const _hoisted_138 = {
  id: "facilittes",
  class: "facilittes fade-in"
}
const _hoisted_139 = { class: "carousel-wrap" }
const _hoisted_140 = ["src"]
const _hoisted_141 = { class: "pic-text" }
const _hoisted_142 = { class: "price-button" }
const _hoisted_143 = { class: "button-wrap" }
const _hoisted_144 = { class: "button" }
const _hoisted_145 = { class: "price-button fade-in" }
const _hoisted_146 = { class: "button-wrap" }
const _hoisted_147 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.slides, (slide, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
            _createElementVNode("img", {
              class: _normalizeClass([_ctx.state.current_slide == idx ? 'active' : '', "slide-img"]),
              src: _ctx.state.slides[idx].img
            }, null, 10, _hoisted_4),
            (_ctx.state.current_slide === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[25] || (_cache[25] = [
                  _createElementVNode("span", { class: "text-gold" }, "美", -1),
                  _createTextVNode("しく ")
                ])))
              : (_ctx.state.current_slide === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[26] || (_cache[26] = [
                    _createElementVNode("span", { class: "text-pink" }, "楽", -1),
                    _createTextVNode("しく ")
                  ])))
                : (_ctx.state.current_slide === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[27] || (_cache[27] = [
                      _createElementVNode("span", { class: "text-gold" }, "華", -1),
                      _createTextVNode("やかに")
                    ])))
                  : (_ctx.state.current_slide === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[28] || (_cache[28] = [
                        _createTextVNode("キック"),
                        _createElementVNode("span", { class: "text-pink" }, "ボ", -1),
                        _createTextVNode("クシングフィットネス")
                      ])))
                    : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.slides2, (slide, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
            _createElementVNode("img", {
              class: _normalizeClass([_ctx.state.current_slide == idx ? 'active' : '', "slide-img"]),
              src: _ctx.state.slides2[idx].img
            }, null, 10, _hoisted_10),
            (_ctx.state.current_slide === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[29] || (_cache[29] = [
                  _createElementVNode("span", { class: "text-gold" }, "美", -1),
                  _createTextVNode("しく ")
                ])))
              : (_ctx.state.current_slide === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[30] || (_cache[30] = [
                    _createElementVNode("span", { class: "text-pink" }, "楽", -1),
                    _createTextVNode("しく ")
                  ])))
                : (_ctx.state.current_slide === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[31] || (_cache[31] = [
                      _createElementVNode("span", { class: "text-gold" }, "華", -1),
                      _createTextVNode("やかに")
                    ])))
                  : (_ctx.state.current_slide === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[32] || (_cache[32] = [
                        _createTextVNode("キック"),
                        _createElementVNode("span", { class: "text-pink" }, "ボ", -1),
                        _createTextVNode("クシング"),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("フィットネス")
                      ])))
                    : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("section", _hoisted_16, [
        _cache[34] || (_cache[34] = _createStaticVNode("<div id=\"concept\" class=\"concept\" data-v-42963e7e><div class=\"top-items-title fade-in\" data-v-42963e7e><h2 data-v-42963e7e>Concept</h2><p data-v-42963e7e>キックボクシングをやって元気に</p></div><div class=\"fade-in top-content-des\" data-v-42963e7e><p data-v-42963e7e>痩せたい...</p><p data-v-42963e7e>運動不足を解消したい...</p><p data-v-42963e7e>試合に出てみたい...</p><p data-v-42963e7e>強くなりたい...</p><p data-v-42963e7e>etc...</p></div><div class=\"fade-in top-content-des\" data-v-42963e7e><p data-v-42963e7e>CYCLONE GYMでは会員様の理想とする身体に仕上げられるようお手伝いさせて頂きます。</p></div><div class=\"concept-bg\" data-v-42963e7e> Make The Body<br data-v-42963e7e> You Dream About </div></div>", 1)),
        _createElementVNode("div", _hoisted_17, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "News"),
            _createElementVNode("p", null, "お知らせ")
          ], -1)),
          _createElementVNode("ul", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.news, (obj, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "news-list-item"
              }, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.setCurrentPage,
                  to: {
                  name: 'News',
                  query: { id: obj.id },
                }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(obj.date), 1),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(obj.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "to"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(['news-button', { none: _ctx.isButtonActive('prev') }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevButton && _ctx.prevButton(...args)))
            }, " 前へ ", 2),
            _createTextVNode(" " + _toDisplayString(_ctx.state.currenPage) + " / " + _toDisplayString(Math.ceil(_ctx.state.news2.length / 5)) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(['news-button', { none: _ctx.isButtonActive('next') }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextButton && _ctx.nextButton(...args)))
            }, " 次へ ", 2)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Lesson", -1)),
            _cache[37] || (_cache[37] = _createElementVNode("p", null, "スケジュール", -1)),
            _createElementVNode("div", _hoisted_25, [
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "checkbox-list-text" }, "こちらからスケジュール表を切り替えられます", -1)),
              _createElementVNode("ul", _hoisted_26, [
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('月曜日') }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectWeek('月曜日')))
                }, "月曜日", 2),
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('火曜日') }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectWeek('火曜日')))
                }, "火曜日", 2),
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('水曜日') }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectWeek('水曜日')))
                }, "水曜日", 2),
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('木曜日') }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectWeek('木曜日')))
                }, "木曜日", 2),
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('金曜日') }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectWeek('金曜日')))
                }, "金曜日", 2),
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('土曜日') }]),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectWeek('土曜日')))
                }, "土曜日", 2),
                _createElementVNode("li", {
                  class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct2('日曜日') }]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectWeek('日曜日')))
                }, "日曜日", 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("ul", null, [
                _cache[45] || (_cache[45] = _createStaticVNode("<li class=\"hours\" data-v-42963e7e><dl data-v-42963e7e><dt data-v-42963e7e></dt><dd data-v-42963e7e><p data-v-42963e7e>10:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>11:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>12:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>13:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>14:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>15:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>16:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>17:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>18:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>19:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>20:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>21:00</p></dd><dd data-v-42963e7e><p data-v-42963e7e>22:00</p></dd></dl></li>", 1)),
                (!_ctx.state.isSP || _ctx.state.week[0] === '月曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_29, _cache[38] || (_cache[38] = [
                      _createStaticVNode("<dl data-v-42963e7e><dt data-v-42963e7e>月曜日</dt><dd class=\"classBiginer\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック初級<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classYOGA\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ミットスキル<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classFit row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ボディメイク<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classRegi row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>筋膜リリース<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"row-4\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-2 row-flex\" data-v-42963e7e><div class=\"classStrengthen\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>強化<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※選手<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div><div class=\"classStudent\" data-v-42963e7e><div data-v-42963e7e><p class=\"class\" data-v-42963e7e>学生<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※学生入門<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div></div></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"classRhythm\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>CLUB<br data-v-42963e7e>リズムキック<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-close\" data-v-42963e7e>CLOSE</dd></dl>", 1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.state.isSP || _ctx.state.week[0] === '火曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_30, _cache[39] || (_cache[39] = [
                      _createStaticVNode("<dl data-v-42963e7e><dt data-v-42963e7e>火曜日</dt><dd class=\"classBiginer\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック初級<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classRegi row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>筋膜リリース<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classFit row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ボディメイク<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"row-5\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-2 row-flex\" data-v-42963e7e><div class=\"classStrengthen\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>強化<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※選手<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div><div class=\"classStudent\" data-v-42963e7e><div data-v-42963e7e><p class=\"class\" data-v-42963e7e>学生<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※学生入門<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div></div></dd><dd class=\"row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"classEntry row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>エントリーキック<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classBiginer\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック初級<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-close\" data-v-42963e7e>CLOSE</dd></dl>", 1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.state.isSP || _ctx.state.week[0] === '水曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_31, _cache[40] || (_cache[40] = [
                      _createStaticVNode("<dl data-v-42963e7e><dt data-v-42963e7e>水曜日</dt><dd class=\"classLadies\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>レディースキック<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classFat row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ファットバーン<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classRegi row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>筋膜リリース<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"row-5\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-2 row-flex\" data-v-42963e7e><div class=\"classStrengthen\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>強化<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※選手<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div><div class=\"classStudent\" data-v-42963e7e><div data-v-42963e7e><p class=\"class\" data-v-42963e7e>学生<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※学生入門<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div></div></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"classFit row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ボディメイク<br data-v-42963e7e>クラス<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classFat row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ファットバーン<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-close\" data-v-42963e7e>CLOSE</dd></dl>", 1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.state.isSP || _ctx.state.week[0] === '木曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_32, _cache[41] || (_cache[41] = [
                      _createStaticVNode("<dl data-v-42963e7e><dt data-v-42963e7e>木曜日</dt><dd class=\"classBiginer\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック初級<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classFit row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ボディメイク<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classRegi row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>筋膜リリース<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"row-5\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-2 row-flex\" data-v-42963e7e><div class=\"classStrengthen\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>強化<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※選手<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div><div class=\"classStudent\" data-v-42963e7e><div data-v-42963e7e><p class=\"class\" data-v-42963e7e>学生<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※学生入門<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div></div></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"classBiginer\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック初級<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-close\" data-v-42963e7e>CLOSE</dd></dl>", 1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.state.isSP || _ctx.state.week[0] === '金曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_33, _cache[42] || (_cache[42] = [
                      _createStaticVNode("<dl data-v-42963e7e><dt data-v-42963e7e>金曜日</dt><dd class=\"classLadiesEntry row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>レディースエントリー<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classLadies\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>レディースキック<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classBiginer2 row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック中級<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classSPA\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>マススパーリング<br data-v-42963e7e>クラス<span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"row-4\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-2 row-flex\" data-v-42963e7e><div class=\"classStrengthen\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>強化<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※選手<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div><div class=\"classStudent\" data-v-42963e7e><div data-v-42963e7e><p class=\"class\" data-v-42963e7e>学生<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※学生入門<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div></div></dd><dd class=\"row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"classBiginer2 row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック中級<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classSPA\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>マススパーリング<br data-v-42963e7e>クラス<span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-close\" data-v-42963e7e>CLOSE</dd></dl>", 1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.state.isSP || _ctx.state.week[0] === '土曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_34, _cache[43] || (_cache[43] = [
                      _createStaticVNode("<dl data-v-42963e7e><dt data-v-42963e7e>土曜日</dt><dd class=\"row-2\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"classFit row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ボディメイク<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classFat row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>ファットバーン<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"classBiginer\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>キック初級<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classRhythm\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>リズムキック<br data-v-42963e7e><span class=\"keep\" data-v-42963e7e>（1時間）</span></p></dd><dd class=\"classRegi row-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>筋膜リリース<span class=\"keep\" data-v-42963e7e>(30分)</span></p></dd><dd class=\"row-1-05\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-2 row-flex\" data-v-42963e7e><div class=\"classStrengthen\" data-v-42963e7e><p class=\"class\" data-v-42963e7e>強化<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※選手<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div><div class=\"classStudent\" data-v-42963e7e><div data-v-42963e7e><p class=\"class\" data-v-42963e7e>学生<span class=\"keep\" data-v-42963e7e>クラス</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e>※学生入門<span class=\"keep\" data-v-42963e7e>コース</span></span></p></div></div></dd><dd data-v-42963e7e><p class=\"class\" data-v-42963e7e>フリータイム<br data-v-42963e7e>ミット対応可</p></dd><dd class=\"row-3 row-close\" data-v-42963e7e>CLOSE</dd></dl>", 1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.state.isSP || _ctx.state.week[0] === '日曜日' && _ctx.state.isSP)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_35, _cache[44] || (_cache[44] = [
                      _createElementVNode("dl", null, [
                        _createElementVNode("dt", null, "日曜日"),
                        _createElementVNode("dd", { class: "row-2 row-close" }, "CLOSE"),
                        _createElementVNode("dd", { class: "row-6" }, [
                          _createElementVNode("p", { class: "class" }, [
                            _createTextVNode("フリータイム"),
                            _createElementVNode("br"),
                            _createTextVNode("ミット対応可")
                          ])
                        ]),
                        _createElementVNode("dd", { class: "row-5 row-close" }, "CLOSE")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _cache[46] || (_cache[46] = _createElementVNode("p", { class: "lesson-schedule-note2" }, [
                _createTextVNode("※クラス以外の時間はフリータイムとなりますので、"),
                _createElementVNode("span", { class: "pc-none-inline" }, [
                  _createElementVNode("br")
                ]),
                _createTextVNode("ミット対応可能です ")
              ], -1))
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "annotation-wrap" }, [
            _createElementVNode("p", { class: "annotation" }, "※レッスン開始５分後までに参加者が2名に満たなかった場合、レッスンは休講となりフリータイムとなります。")
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_36, [
        _cache[145] || (_cache[145] = _createStaticVNode("<div id=\"menu\" class=\"menu fade-in\" data-v-42963e7e><div class=\"top-items-title\" data-v-42963e7e><h2 data-v-42963e7e>Lesson</h2><p data-v-42963e7e>クラス紹介</p></div><ul class=\"menu-list\" data-v-42963e7e><li class=\"menu-list-item\" data-v-42963e7e><div class=\"menu-list-wrap\" data-v-42963e7e><div class=\"menu-list-img\" data-v-42963e7e><img src=\"" + _imports_0 + "\" data-v-42963e7e></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>キック初級クラス</div><div class=\"menu-list-des\" data-v-42963e7e> キックが初めての方でも楽しめ<br data-v-42963e7e> 更に基礎からしっかり学べます！ </div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>キック中級クラス</div><div class=\"menu-list-des\" data-v-42963e7e> 対人練習をメインに簡単な攻撃・防御を行うクラス。<br data-v-42963e7e> 金曜日20:00〜のマススパーリングクラス前に練習し、<br data-v-42963e7e> 実戦で出来るように行なっていきます。<br data-v-42963e7e> 常に頭を使いながら身体を動かすので、代謝アップに繋がります。<br data-v-42963e7e></div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>エントリーキッククラス<br data-v-42963e7e>レディースエントリーキッククラス</div><div class=\"menu-list-des\" data-v-42963e7e> キックボクシング入門の初心者向けクラス。<br data-v-42963e7e> 正しいフォームからパンチ・キックを細かく説明しながら行なっていきます。<br data-v-42963e7e> 慣れている方でも初心に帰って、見直すことも出来るのでオススメです。 </div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>レディースキッククラス</div><div class=\"menu-list-des\" data-v-42963e7e> 女性限定のキックボクシングクラス。<br data-v-42963e7e> 老若男女みんなでのトレーニングに緊張してしまう方や、<br data-v-42963e7e> 周りの目を気にしてしまう方、ついていけるか心配…<br data-v-42963e7e> そんな女性の方は是非こちらのクラスへご参加ください。 </div></div><div class=\"menu-list-img\" data-v-42963e7e><img src=\"" + _imports_1 + "\" data-v-42963e7e></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>リズムキッククラス</div><div class=\"menu-list-des\" data-v-42963e7e>音楽をかけキックボクシングの動きを<br data-v-42963e7e>使ってリズムにのって楽しく動くクラスです！</div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>CLUBリズムキッククラス</div><div class=\"menu-list-des\" data-v-42963e7e> 暗闇空間でのムービングライトの照明演出の中、爆音の音楽の合わせてキックボクシングを行うクラス。<br data-v-42963e7e> リズムキッククラスとは違い、人目を気にすることなく非日常空間で高揚感を感じながら有酸素運動が行えます。 </div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>強化クラス</div><div class=\"menu-list-des\" data-v-42963e7e>17:00〜19:00は選手育成コース<br data-v-42963e7e> 心と身体共に鍛えることを初め、<br data-v-42963e7e> 芯を強くしていきます！試合にも出場できます！</div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>学生クラス</div><div class=\"menu-list-des\" data-v-42963e7e>17:00〜18:30のキックボクシング入門コース<br data-v-42963e7e> ※学生会員はこちらになります。(対象：小学校1年生〜中学校3年生 ※高校生以上の方は一般会員となります)<br data-v-42963e7e> 礼儀を中心にキックボクシングを学びダイエットや運動不足解消、フィットネスとして行なっていきます。<br data-v-42963e7e><span style=\"font-size:80%;\" data-v-42963e7e>(対象：小学校1年生〜中学校3年生 ※高校生以上の方は一般会員となります)</span></div></div><div class=\"menu-list-img\" data-v-42963e7e><img src=\"" + _imports_2 + "\" data-v-42963e7e></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>ミットスキルクラス</div><div class=\"menu-list-des\" data-v-42963e7e> 会員様同士でミットを持ち合うクラスになります。<br data-v-42963e7e> ミット持ちのスキルを学ぶことで、キックボクシングの上達を計ることが出来ます。フリータイムの中での仲の良い会員様同士のコミニケーション向上にも繋がります。 </div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>ボディメイククラス</div><div class=\"menu-list-des\" data-v-42963e7e>下半身から上半身まで、参加者のレベルに合わせた<br data-v-42963e7e>ボディメイクトレーニングが出来ます！<br data-v-42963e7e><span data-v-42963e7e>※中履きが必要です</span></div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>ファットバーンクラス</div><div class=\"menu-list-des\" data-v-42963e7e>タバタ式トレーニングで脂肪燃焼 有酸素運動が苦手な方も<br data-v-42963e7e>しっかり動いて燃焼出来るクラスです！</div></div><div class=\"menu-list-img\" data-v-42963e7e><img src=\"" + _imports_3 + "\" data-v-42963e7e></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>マススパーリングクラス</div><div class=\"menu-list-des\" data-v-42963e7e> 試合形式で行う、実践トレーニングとなります。<br data-v-42963e7e>レガース(足にはめる防具)、大きめのグローブ(16oz)をつけて相手にダメージを与えることなく、攻撃や防御のトレーニングになります。<br data-v-42963e7e>ミットよりさらに実践的になったパンチやキックをディフェンスを駆使し動くため運動量が多くなり、脂肪燃焼の効果はより高まります。 </div></div><div class=\"menu-list-text\" data-v-42963e7e><div class=\"menu-list-title\" data-v-42963e7e>筋膜リリースクラス</div><div class=\"menu-list-des\" data-v-42963e7e> フォームローラーを使って身体を解していくストレッチ中心のクラス。<br data-v-42963e7e> 身体の柔軟性・姿勢・パフォーマンスの向上・肩こり・腰痛の改善に繋がります。<br data-v-42963e7e> クラス前やクラス後にオススメです。 </div><p class=\"annotation mt16 pl0\" data-v-42963e7e>※レッスン開始５分後までに参加者が2名に満たなかった場合、<br class=\"sp-none\" data-v-42963e7e>レッスンは休講となりフリータイムとなります。 </p></div></div></li></ul><div class=\"menu-list-bg\" data-v-42963e7e><img src=\"" + _imports_0 + "\" data-v-42963e7e></div><div class=\"menu-list-bg menu-list-bg2\" data-v-42963e7e><img src=\"" + _imports_1 + "\" data-v-42963e7e></div><div class=\"menu-list-bg menu-list-bg3\" data-v-42963e7e><img src=\"" + _imports_2 + "\" data-v-42963e7e></div><div class=\"menu-list-bg menu-list-bg4\" data-v-42963e7e><img src=\"" + _imports_3 + "\" data-v-42963e7e></div><div class=\"menu-list-bg menu-list-bg5\" data-v-42963e7e><img src=\"" + _imports_4 + "\" data-v-42963e7e></div></div>", 1)),
        _createElementVNode("div", _hoisted_37, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "attention" }, [
            _createElementVNode("p", null, [
              _createTextVNode("体験、見学受付中"),
              _createElementVNode("br"),
              _createTextVNode("こちらから")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_router_link, {
                to: "/Contact",
                onClick: _ctx.onTapReturnButton
              }, {
                default: _withCtx(() => _cache[48] || (_cache[48] = [
                  _createElementVNode("div", { class: "icon-arrow-left" }, null, -1),
                  _createTextVNode(" お問い合わせ ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "top-items-title" }, [
              _createElementVNode("h2", null, "Price"),
              _createElementVNode("p", null, "料金")
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "attention-wrap" }, [
                _createElementVNode("div", { class: "attention" }, [
                  _createElementVNode("p", null, "キャンペーン実施中")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[51] || (_cache[51] = _createStaticVNode("<div class=\"price-cam-item-title\" data-v-42963e7e>新規でご検討の方</div><div class=\"price-cam-item-des\" data-v-42963e7e><div class=\"price-cam-item-des-title\" data-v-42963e7e>新規入会キャンペーン</div><div class=\"price-cam-item-des-text\" data-v-42963e7e> 入会金<span class=\"fw\" data-v-42963e7e>無料！</span><br data-v-42963e7e> 初月会費<span class=\"fw\" data-v-42963e7e>無料！</span><br data-v-42963e7e><div class=\"lh1\" data-v-42963e7e> 顔認証登録手数料の<br data-v-42963e7e><div class=\"price-item-des-numtext fs26\" data-v-42963e7e>2200</div>円が <span class=\"fw\" data-v-42963e7e>今だけ無料！</span></div></div><div class=\"price-cam-item-note\" data-v-42963e7e><div class=\"price-cam-item-note-title\" data-v-42963e7e>注意事項</div><div class=\"price-cam-item-note-text\" data-v-42963e7e> ・本キャンペーンのご入会の場合６ヶ月の在籍が必要となります。 <br data-v-42963e7e> また期間内での退会・休会理由の如何を問わず６ヶ月の在籍条件となりますので、ご注意ください。 <br data-v-42963e7e> ・ビジターはキャンペーン適用外です。 </div></div></div>", 2)),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_router_link, {
                        to: "#price-list",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectPrice('新規入会キャンペーン')))
                      }, {
                        default: _withCtx(() => _cache[50] || (_cache[50] = [
                          _createTextVNode(" キャンペーン適用時の"),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode(" 料金を確認する ")
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _cache[53] || (_cache[53] = _createStaticVNode("<div class=\"price-cam-item-title\" data-v-42963e7e>スポーツジムの乗り換えを<span class=\"pc-none-inline\" data-v-42963e7e><br data-v-42963e7e></span>ご検討の方</div><div class=\"price-cam-item-des\" data-v-42963e7e><div class=\"price-cam-item-des-title\" data-v-42963e7e>のりかえキャンペーン</div><div class=\"price-cam-item-des-text\" data-v-42963e7e> 初月会費<span class=\"fw\" data-v-42963e7e>無料！</span><br data-v-42963e7e> 2ヶ月目の月会費<span class=\"fw\" data-v-42963e7e>半額！</span><br data-v-42963e7e><div class=\"lh1\" data-v-42963e7e> 顔認証登録手数料の<br data-v-42963e7e><div class=\"price-item-des-numtext fs26\" data-v-42963e7e>2200</div>円が <span class=\"fw\" data-v-42963e7e>今だけ無料！</span></div></div><div class=\"price-cam-item-note\" data-v-42963e7e><div class=\"price-cam-item-note-title\" data-v-42963e7e>注意事項</div><div class=\"price-cam-item-note-text\" data-v-42963e7e> ・2ヶ月以内にスポーツジム(格闘技・フィットネスジム・ヨガなども含む) 又はキックボクシングを退会された方、退会予定の方に限り適用されます。<br data-v-42963e7e> ・前所属の会員証、又は退会届をお持ちください。 </div></div></div>", 2)),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_router_link, {
                        to: "#price-list",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectPrice('のりかえキャンペーン')))
                      }, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createTextVNode(" キャンペーン適用時の"),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode(" 料金を確認する ")
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _cache[55] || (_cache[55] = _createStaticVNode("<div class=\"price-cam-item-title\" data-v-42963e7e>平日昼間をご検討の方</div><div class=\"price-cam-item-des\" data-v-42963e7e><div class=\"price-cam-item-des-title\" data-v-42963e7e>デイタイムキャンペーン</div><div class=\"price-cam-item-des-text\" data-v-42963e7e> 男性会員 女性会員 <span class=\"fw\" data-v-42963e7e>共通！</span><br data-v-42963e7e><span class=\"text-blue\" data-v-42963e7e>男性</span><div class=\"price-item-des-numtext\" data-v-42963e7e>8500</div>円 <span class=\"pc-none-inline\" data-v-42963e7e><br data-v-42963e7e></span><span class=\"text-pink\" data-v-42963e7e>女性</span><div class=\"price-item-des-numtext\" data-v-42963e7e>8000</div> 円 <div class=\"arrow-bottom\" data-v-42963e7e></div><span class=\"fade-in mb20\" data-v-42963e7e>キャンペーン中のご入会に限り！</span><br data-v-42963e7e><div class=\"fwra\" data-v-42963e7e><span class=\"fade-in\" data-v-42963e7e>この先</span><span class=\"fw fade-in fade-in-text\" data-v-42963e7e><span data-v-42963e7e>ず</span><span data-v-42963e7e>ー</span><span data-v-42963e7e>ー</span><span data-v-42963e7e>ー</span><span data-v-42963e7e>っ</span><span data-v-42963e7e>と</span></span></div><div class=\"price-item-des-numtext2-wrap\" data-v-42963e7e><span class=\"fw fb fade-in price-item-des-numtext2\" data-v-42963e7e>5880円！！</span></div><div class=\"mb40 mt40\" data-v-42963e7e><span class=\"fw fade-in fade-in-text\" data-v-42963e7e><span data-v-42963e7e>さ</span><span data-v-42963e7e>ら</span><span data-v-42963e7e>に</span></span></div><div class=\"lh1\" data-v-42963e7e> 顔認証登録手数料の<br data-v-42963e7e><div class=\"price-item-des-numtext fs26\" data-v-42963e7e>2200</div>円が <span class=\"fw\" data-v-42963e7e>今だけ無料！</span></div><div class=\"fade-in\" data-v-42963e7e> 初月会費も<span class=\"fw\" data-v-42963e7e>無料！</span><br data-v-42963e7e> 入会金も<span class=\"fw\" data-v-42963e7e>無料！</span></div><div class=\"box4 fade-in\" data-v-42963e7e><p data-v-42963e7e> 月〜金 10:00〜16:00 </p><div class=\"con1\" data-v-42963e7e> キックボクシングだけじゃなく<br data-v-42963e7e> 筋トレエリア、筋トレクラスの<span class=\"fw\" data-v-42963e7e>利用可能！！</span></div><div class=\"con1\" data-v-42963e7e> ジム内全て使えて、<span class=\"fw\" data-v-42963e7e>充実の6時間！</span><br data-v-42963e7e><span class=\"sm\" data-v-42963e7e> ※最終退館時刻は15:50となります。 </span></div></div></div><div class=\"price-cam-item-note\" data-v-42963e7e><div class=\"price-cam-item-note-title\" data-v-42963e7e>注意事項</div><div class=\"price-cam-item-note-text\" data-v-42963e7e> ・入会キャンペーンと同様、6ヶ月間の在籍が必要となります。<br data-v-42963e7e></div></div></div>", 2)),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_router_link, {
                          to: "#price-list",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectPrice('デイタイムキャンペーン')))
                        }, {
                          default: _withCtx(() => _cache[54] || (_cache[54] = [
                            _createTextVNode(" キャンペーン適用時の"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 料金を確認する ")
                          ])),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _cache[57] || (_cache[57] = _createStaticVNode("<div class=\"price-cam-item-title\" data-v-42963e7e>体験をご検討の方</div><div class=\"price-cam-item-des\" data-v-42963e7e><div class=\"price-cam-item-des-title\" data-v-42963e7e>体験料<span class=\"pc-none-inline\" data-v-42963e7e><br data-v-42963e7e></span>キャッシュバック<span class=\"pc-none-inline\" data-v-42963e7e><br data-v-42963e7e></span>キャンペーン</div><div class=\"price-cam-item-des-text\" data-v-42963e7e> 体験料<br data-v-42963e7e><span class=\"fw\" data-v-42963e7e>全額キャッシュバック！</span><br data-v-42963e7e> 入会金<span class=\"fw\" data-v-42963e7e>無料！</span><br data-v-42963e7e> 初月会費<span class=\"fw\" data-v-42963e7e>無料！</span><br data-v-42963e7e><div class=\"lh1\" data-v-42963e7e> 顔認証登録手数料の<br data-v-42963e7e><div class=\"price-item-des-numtext fs26\" data-v-42963e7e>2200</div>円が <span class=\"fw\" data-v-42963e7e>今だけ無料！</span></div></div><div class=\"price-cam-item-note\" data-v-42963e7e><div class=\"price-cam-item-note-title\" data-v-42963e7e>注意事項</div><div class=\"price-cam-item-note-text\" data-v-42963e7e> ・体験から2週間以内にご入会の場合の方に限り適用されます。<br data-v-42963e7e></div></div></div>", 2)),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_router_link, {
                          to: "/Contact",
                          onClick: _ctx.onTapReturnButton
                        }, {
                          default: _withCtx(() => _cache[56] || (_cache[56] = [
                            _createTextVNode(" 体験予約する"),
                            _createElementVNode("br", null, null, -1)
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _cache[60] || (_cache[60] = _createElementVNode("h2", null, "Price", -1)),
              _cache[61] || (_cache[61] = _createElementVNode("p", null, "料金表", -1)),
              _createElementVNode("div", null, "- " + _toDisplayString(_ctx.state.price[0]) + " -", 1)
            ]),
            _cache[62] || (_cache[62] = _createElementVNode("div", { class: "checkbox-list-text" }, "こちらから料金表を切り替えられます", -1)),
            _createElementVNode("ul", _hoisted_60, [
              _createElementVNode("li", {
                class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct('通常料金') }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectPrice('通常料金')))
              }, "通常料金", 2),
              _createElementVNode("li", {
                class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct('新規入会キャンペーン') }]),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectPrice('新規入会キャンペーン')))
              }, " 新規入会キャンペーン", 2),
              _createElementVNode("li", {
                class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct('のりかえキャンペーン') }]),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectPrice('のりかえキャンペーン')))
              }, " のりかえキャンペーン", 2),
              _createElementVNode("li", {
                class: _normalizeClass(['checkbox__item', { on: _ctx.isCheckedProduct('デイタイムキャンペーン') }]),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectPrice('デイタイムキャンペーン')))
              }, " デイタイムキャンペーン", 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("ul", _hoisted_62, [
              _createElementVNode("li", _hoisted_63, [
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "price-list-title" }, "入会金", -1)),
                (_ctx.state.price[0] === '通常料金')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, _cache[63] || (_cache[63] = [
                      _createElementVNode("div", { class: "price-list-des-grid2" }, "11,000円", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_65, _cache[64] || (_cache[64] = [
                      _createElementVNode("div", { class: "price-list-des-grid2" }, [
                        _createElementVNode("span", { class: "text-pink2" }, "0"),
                        _createTextVNode("円")
                      ], -1)
                    ])))
              ]),
              (_ctx.state.price[0] != 'デイタイムキャンペーン')
                ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
                    _cache[72] || (_cache[72] = _createElementVNode("div", { class: "price-list-title" }, "一般会員", -1)),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _cache[68] || (_cache[68] = _createElementVNode("span", { class: "text-blue" }, " 男性 ", -1)),
                        (_ctx.state.price[0] === '通常料金')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 12,000円 ")
                            ], 64))
                          : (_ctx.state.price[0] === '新規入会キャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, _cache[66] || (_cache[66] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 12,000円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : (_ctx.state.price[0] === 'のりかえキャンペーン')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, _cache[67] || (_cache[67] = [
                                  _createTextVNode(" 初月 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 2ヶ月目 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "6,000", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 3ヶ月目以降 12,000円"),
                                  _createElementVNode("br", null, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _cache[71] || (_cache[71] = _createElementVNode("span", { class: "text-pink" }, " 女性 ", -1)),
                        (_ctx.state.price[0] === '通常料金')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 10,000円 ")
                            ], 64))
                          : (_ctx.state.price[0] === '新規入会キャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, _cache[69] || (_cache[69] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 10,000円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : (_ctx.state.price[0] === 'のりかえキャンペーン')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, _cache[70] || (_cache[70] = [
                                  _createTextVNode(" 初月 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 2ヶ月目 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "5,000", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 3ヶ月目以降 10,000円"),
                                  _createElementVNode("br", null, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.price[0] != 'デイタイムキャンペーン')
                ? (_openBlock(), _createElementBlock("li", _hoisted_74, [
                    _cache[79] || (_cache[79] = _createElementVNode("div", { class: "price-list-title" }, "月4回会員", -1)),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _cache[75] || (_cache[75] = _createElementVNode("span", { class: "text-blue" }, " 男性 ", -1)),
                        (_ctx.state.price[0] === '通常料金')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 6,500円 ")
                            ], 64))
                          : (_ctx.state.price[0] === '新規入会キャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, _cache[73] || (_cache[73] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 6,500円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : (_ctx.state.price[0] === 'のりかえキャンペーン')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, _cache[74] || (_cache[74] = [
                                  _createTextVNode(" 初月 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 2ヶ月目 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "3,250", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 3ヶ月目以降 6,500円"),
                                  _createElementVNode("br", null, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _cache[78] || (_cache[78] = _createElementVNode("span", { class: "text-pink" }, " 女性 ", -1)),
                        (_ctx.state.price[0] === '通常料金')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 5,500円 ")
                            ], 64))
                          : (_ctx.state.price[0] === '新規入会キャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _cache[76] || (_cache[76] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 5,500円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : (_ctx.state.price[0] === 'のりかえキャンペーン')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, _cache[77] || (_cache[77] = [
                                  _createTextVNode(" 初月 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 2ヶ月目 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "2,750", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 3ヶ月目以降 5,500円"),
                                  _createElementVNode("br", null, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_82, [
                _cache[88] || (_cache[88] = _createElementVNode("div", { class: "price-list-title" }, [
                  _createTextVNode("デイタイム会員"),
                  _createElementVNode("br"),
                  _createTextVNode("（月〜金10:00〜16:00）")
                ], -1)),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _cache[83] || (_cache[83] = _createElementVNode("span", { class: "text-blue" }, " 男性 ", -1)),
                    (_ctx.state.price[0] === '通常料金')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" 8,500円 ")
                        ], 64))
                      : (_ctx.state.price[0] === '新規入会キャンペーン')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, _cache[80] || (_cache[80] = [
                            _createTextVNode(" 初月 "),
                            _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                            _createTextVNode("円"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 2ヶ月目以降 8,500円"),
                            _createElementVNode("br", null, null, -1)
                          ])))
                        : (_ctx.state.price[0] === 'のりかえキャンペーン')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, _cache[81] || (_cache[81] = [
                              _createTextVNode(" 初月 "),
                              _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                              _createTextVNode("円"),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 2ヶ月目 "),
                              _createElementVNode("span", { class: "text-pink2" }, "4,250", -1),
                              _createTextVNode("円"),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 3ヶ月目以降 8,500円"),
                              _createElementVNode("br", null, null, -1)
                            ])))
                          : (_ctx.state.price[0] === 'デイタイムキャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, _cache[82] || (_cache[82] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 "),
                                _createElementVNode("span", { class: "text-pink2" }, "5,880", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _cache[87] || (_cache[87] = _createElementVNode("span", { class: "text-pink" }, " 女性 ", -1)),
                    (_ctx.state.price[0] === '通常料金')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" 8,000円 ")
                        ], 64))
                      : (_ctx.state.price[0] === '新規入会キャンペーン')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, _cache[84] || (_cache[84] = [
                            _createTextVNode(" 初月 "),
                            _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                            _createTextVNode("円"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" 2ヶ月目以降 8,000円"),
                            _createElementVNode("br", null, null, -1)
                          ])))
                        : (_ctx.state.price[0] === 'のりかえキャンペーン')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, _cache[85] || (_cache[85] = [
                              _createTextVNode(" 初月 "),
                              _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                              _createTextVNode("円"),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 2ヶ月目 "),
                              _createElementVNode("span", { class: "text-pink2" }, "4,000", -1),
                              _createTextVNode("円"),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 3ヶ月目以降 8,000円"),
                              _createElementVNode("br", null, null, -1)
                            ])))
                          : (_ctx.state.price[0] === 'デイタイムキャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, _cache[86] || (_cache[86] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 "),
                                _createElementVNode("span", { class: "text-pink2" }, "5,880", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.state.price[0] != 'デイタイムキャンペーン')
                ? (_openBlock(), _createElementBlock("li", _hoisted_92, [
                    _cache[91] || (_cache[91] = _createElementVNode("div", { class: "price-list-title" }, [
                      _createTextVNode("学生会員(中学3年生まで）"),
                      _createElementVNode("br"),
                      _createElementVNode("span", { style: {"font-size":"80%"} }, "高校生から一般会員になります。")
                    ], -1)),
                    _createElementVNode("div", _hoisted_93, [
                      (_ctx.state.price[0] === '通常料金')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, "7,500円"))
                        : (_ctx.state.price[0] === '新規入会キャンペーン')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, _cache[89] || (_cache[89] = [
                              _createTextVNode(" 初月 "),
                              _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                              _createTextVNode("円"),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 2ヶ月目以降 7,500円"),
                              _createElementVNode("br", null, null, -1)
                            ])))
                          : (_ctx.state.price[0] === 'のりかえキャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, _cache[90] || (_cache[90] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目 "),
                                _createElementVNode("span", { class: "text-pink2" }, "3,750", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 3ヶ月目以降 7,500円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.price[0] != 'デイタイムキャンペーン')
                ? (_openBlock(), _createElementBlock("li", _hoisted_97, [
                    _cache[98] || (_cache[98] = _createElementVNode("div", { class: "price-list-title" }, "シルバー会員（60歳以上）", -1)),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _cache[94] || (_cache[94] = _createElementVNode("span", { class: "text-blue" }, " 男性 ", -1)),
                        (_ctx.state.price[0] === '通常料金')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 8,000円 ")
                            ], 64))
                          : (_ctx.state.price[0] === '新規入会キャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, _cache[92] || (_cache[92] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 8,000円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : (_ctx.state.price[0] === 'のりかえキャンペーン')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_101, _cache[93] || (_cache[93] = [
                                  _createTextVNode(" 初月 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 2ヶ月目 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "4,000", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 3ヶ月目以降 8,000円"),
                                  _createElementVNode("br", null, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _cache[97] || (_cache[97] = _createElementVNode("span", { class: "text-pink" }, " 女性 ", -1)),
                        (_ctx.state.price[0] === '通常料金')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 7,000円 ")
                            ], 64))
                          : (_ctx.state.price[0] === '新規入会キャンペーン')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, _cache[95] || (_cache[95] = [
                                _createTextVNode(" 初月 "),
                                _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                _createTextVNode("円"),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 2ヶ月目以降 7,000円"),
                                _createElementVNode("br", null, null, -1)
                              ])))
                            : (_ctx.state.price[0] === 'のりかえキャンペーン')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_104, _cache[96] || (_cache[96] = [
                                  _createTextVNode(" 初月 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 2ヶ月目 "),
                                  _createElementVNode("span", { class: "text-pink2" }, "3,500", -1),
                                  _createTextVNode("円"),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 3ヶ月目以降 7,000円"),
                                  _createElementVNode("br", null, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.price[0] != 'デイタイムキャンペーン')
                ? (_openBlock(), _createElementBlock("li", _hoisted_105, _cache[99] || (_cache[99] = [
                    _createElementVNode("div", { class: "price-list-title" }, "ビジター", -1),
                    _createElementVNode("div", { class: "price-list-des" }, [
                      _createElementVNode("div", { class: "price-list-des" }, [
                        _createElementVNode("div", { class: "price-list-des-grid2" }, "3,000円 ※現金のみ")
                      ])
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_106, [
                _cache[101] || (_cache[101] = _createElementVNode("div", { class: "price-list-title" }, "顔認証登録手数料", -1)),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    (_ctx.state.price[0] === '通常料金')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, "2,200円"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_110, _cache[100] || (_cache[100] = [
                          _createElementVNode("span", { class: "text-pink2" }, "0", -1),
                          _createTextVNode("円 ")
                        ])))
                  ])
                ])
              ]),
              _cache[102] || (_cache[102] = _createStaticVNode("<li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>体験料</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>2,000円</div></div></div></li>", 1))
            ]),
            _cache[103] || (_cache[103] = _createStaticVNode("<div id=\"price-list2\" class=\"price-list-sub fade-in\" data-v-42963e7e><div class=\"top-items-title\" data-v-42963e7e><h2 data-v-42963e7e>Price</h2><p data-v-42963e7e>料金表</p><div data-v-42963e7e>- 貸し出し -</div></div></div><div class=\"price-list-wrap fade-in\" data-v-42963e7e><ul class=\"price-list\" data-v-42963e7e><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>軍手</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>100円</div></div></div></li><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>レンタルウェア<br data-v-42963e7e>（S〜LLまで）</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>300円</div></div></div></li><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>ハーフパンツ<br data-v-42963e7e>（S〜LLまで）</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>300円</div></div></div></li><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>上下セットアップ</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>500円</div></div></div></li><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>貸し出しロッカー完備</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>月額1,500円<br data-v-42963e7e>マイグローブやレガースなどジムに置いたままに出来ます。</div></div></div></li><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>水（500ml)</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>100円 ※販売</div></div></div></li><li class=\"price-list-item\" data-v-42963e7e><div class=\"price-list-title\" data-v-42963e7e>アクエリアス</div><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des\" data-v-42963e7e><div class=\"price-list-des-grid2\" data-v-42963e7e>150円 ※販売</div></div></div></li></ul></div><div class=\"price-bg\" data-v-42963e7e><img src=\"" + _imports_5 + "\" data-v-42963e7e></div><div class=\"price-bg2\" data-v-42963e7e> TAKE A<br data-v-42963e7e>      BREATH </div>", 4))
          ])
        ]),
        _createElementVNode("div", _hoisted_111, [
          _cache[105] || (_cache[105] = _createElementVNode("div", { class: "attention" }, [
            _createElementVNode("p", null, [
              _createTextVNode("体験、見学受付中"),
              _createElementVNode("br"),
              _createTextVNode("こちらから")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createVNode(_component_router_link, {
                to: "/Contact",
                onClick: _ctx.onTapReturnButton
              }, {
                default: _withCtx(() => _cache[104] || (_cache[104] = [
                  _createElementVNode("div", { class: "icon-arrow-left" }, null, -1),
                  _createTextVNode(" お問い合わせ ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _cache[146] || (_cache[146] = _createStaticVNode("<div id=\"flow\" class=\"flow fade-in\" data-v-42963e7e><div class=\"top-items-title\" data-v-42963e7e><h2 data-v-42963e7e>Flow</h2><p data-v-42963e7e>入会の流れ</p></div><div data-v-42963e7e><div class=\"box26 fade-in\" data-v-42963e7e><span class=\"box-title\" data-v-42963e7e>STEP 1</span><span class=\"box-title-sub\" data-v-42963e7e>ホームページから体験日の予約</span><p data-v-42963e7e>お電話・メールにてご連絡ください。</p></div></div><div class=\"arrow-bottom2\" data-v-42963e7e></div><div class=\"box26 fade-in\" data-v-42963e7e><span class=\"box-title\" data-v-42963e7e>STEP 2</span><div data-v-42963e7e><div data-v-42963e7e><span class=\"box-title-sub\" data-v-42963e7e>ご来館</span><p data-v-42963e7e>当日のお持ち物をご持参の上、ご来館ください。 </p><p data-v-42963e7e>（お持ち物はお電話・メールにてお伝えいたします。） </p></div><div data-v-42963e7e><img src=\"" + _imports_6 + "\" data-v-42963e7e></div></div></div><div class=\"arrow-bottom2\" data-v-42963e7e></div><div class=\"box26 fade-in\" data-v-42963e7e><span class=\"box-title\" data-v-42963e7e>STEP 3</span><div data-v-42963e7e><div data-v-42963e7e><span class=\"box-title-sub\" data-v-42963e7e>体験スタート</span><p data-v-42963e7e>当ジムスタッフが分かりやすくサポートいたします。 </p></div><div data-v-42963e7e><img src=\"" + _imports_7 + "\" data-v-42963e7e></div></div></div><div class=\"arrow-bottom2\" data-v-42963e7e></div><div class=\"box26 fade-in\" data-v-42963e7e><span class=\"box-title\" data-v-42963e7e>STEP 4</span><div data-v-42963e7e><div data-v-42963e7e><span class=\"box-title-sub\" data-v-42963e7e>入会手続き</span><p data-v-42963e7e>入会手続きに必要な書類に記入していただきます。<br data-v-42963e7e> （お手続きのお時間約10分程度） </p></div><div data-v-42963e7e><img src=\"" + _imports_8 + "\" data-v-42963e7e></div></div></div><div class=\"arrow-bottom2\" data-v-42963e7e></div><div class=\"box26 fade-in\" data-v-42963e7e><span class=\"box-title\" data-v-42963e7e>STEP 5</span><div data-v-42963e7e><div data-v-42963e7e><span class=\"box-title-sub\" data-v-42963e7e>顔認証システムにお顔の登録</span><p data-v-42963e7e>ご来館・ご退館の際に必要になります。 </p></div><div data-v-42963e7e><img src=\"" + _imports_9 + "\" data-v-42963e7e></div></div></div><div class=\"arrow-bottom2\" data-v-42963e7e></div><div class=\"box26 fade-in\" data-v-42963e7e><span class=\"box-title\" data-v-42963e7e>STEP 6</span><div data-v-42963e7e><div data-v-42963e7e><span class=\"box-title-sub\" data-v-42963e7e>お手続き完了！</span><p class=\"text-pink2\" data-v-42963e7e>私たちと楽しくレッスンしていきましょう！ </p></div><div data-v-42963e7e><img src=\"" + _imports_10 + "\" data-v-42963e7e></div></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_114, [
          _cache[107] || (_cache[107] = _createElementVNode("div", { class: "attention" }, [
            _createElementVNode("p", null, [
              _createTextVNode("体験、見学受付中"),
              _createElementVNode("br"),
              _createTextVNode("こちらから")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("div", _hoisted_116, [
              _createVNode(_component_router_link, {
                to: "/Contact",
                onClick: _ctx.onTapReturnButton
              }, {
                default: _withCtx(() => _cache[106] || (_cache[106] = [
                  _createElementVNode("div", { class: "icon-arrow-left" }, null, -1),
                  _createTextVNode(" お問い合わせ ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_117, [
          _cache[137] || (_cache[137] = _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "Q & A"),
            _createElementVNode("p", null, "よくある質問")
          ], -1)),
          _createElementVNode("ul", _hoisted_118, [
            _createElementVNode("li", _hoisted_119, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.open3()))
              }, [
                _cache[108] || (_cache[108] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[109] || (_cache[109] = _createElementVNode("div", { class: "qa-list-title" }, "体験・見学利用できますか？", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen3 ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                        _cache[118] || (_cache[118] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1)),
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("span", null, [
                            _cache[111] || (_cache[111] = _createTextVNode(" 営業時間内のスタッフ常駐時であれば、いつでもご見学いただけます。")),
                            _cache[112] || (_cache[112] = _createElementVNode("br", null, null, -1)),
                            _cache[113] || (_cache[113] = _createTextVNode(" 体験はフリータイム枠、キック初級クラス、レディースキッククラス、エントリーキッククラス、レディースエントリークラスのみ可能となります。")),
                            _cache[114] || (_cache[114] = _createElementVNode("br", null, null, -1)),
                            _cache[115] || (_cache[115] = _createTextVNode(" 詳しくは")),
                            _createVNode(_component_router_link, {
                              to: "/Contact",
                              class: "qa-link"
                            }, {
                              default: _withCtx(() => _cache[110] || (_cache[110] = [
                                _createTextVNode("お問い合わせ")
                              ])),
                              _: 1
                            }),
                            _cache[116] || (_cache[116] = _createTextVNode("のご希望の日付をご確認いただき、お問い合わせください。")),
                            _cache[117] || (_cache[117] = _createElementVNode("br", null, null, -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_122, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.open6()))
              }, [
                _cache[119] || (_cache[119] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[120] || (_cache[120] = _createElementVNode("div", { class: "qa-list-title" }, "レッスンに予約は必要ですか？", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen6 ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen6)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_123, _cache[121] || (_cache[121] = [
                        _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1),
                        _createElementVNode("div", { class: "qa-list-text" }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(" どのクラスも予約は入りません。クラス開催10分前までにお越しください。"),
                            _createElementVNode("br"),
                            _createTextVNode(" 途中参加、途中退出も可能なっておりますので、お気軽にご参加くださいませ。 ")
                          ])
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_124, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.open4()))
              }, [
                _cache[122] || (_cache[122] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[123] || (_cache[123] = _createElementVNode("div", { class: "qa-list-title" }, "体験・見学のお時間はどのくらいですか？", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen4 ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, _cache[124] || (_cache[124] = [
                        _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1),
                        _createElementVNode("div", { class: "qa-list-text" }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(" フリータイム枠は30〜40分となっております。"),
                            _createElementVNode("br"),
                            _createTextVNode("キック初級クラス、レディースキッククラスは1時間となっております。"),
                            _createElementVNode("br"),
                            _createTextVNode("エントリーキッククラス、レディースエントリークラスは30分となっております。 ")
                          ])
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_126, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.open5()))
              }, [
                _cache[125] || (_cache[125] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[126] || (_cache[126] = _createElementVNode("div", { class: "qa-list-title" }, "フリータイムの体験と各クラスの体験は何をやるんですか？", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen5 ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, _cache[127] || (_cache[127] = [
                        _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1),
                        _createElementVNode("div", { class: "qa-list-text" }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(" フリータイムはトレーナーと1対1でキックボクシングの基本動作をご体験していただきます。"),
                            _createElementVNode("br"),
                            _createTextVNode("キック初級クラス、レディースキッククラスの体験は実際のレッスンを1時間、 エントリーキッククラス、レディースエントリークラスは30分、会員様とご一緒にご体験していただきます。 ")
                          ])
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_128, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.open()))
              }, [
                _cache[128] || (_cache[128] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[129] || (_cache[129] = _createElementVNode("div", { class: "qa-list-title" }, "入会手続き（本会員登録）に必要なものはありますか？", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_129, _cache[130] || (_cache[130] = [
                        _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1),
                        _createElementVNode("div", { class: "qa-list-text" }, [
                          _createTextVNode(" 1.現住所が記載された本人確認書類いずれか1点"),
                          _createElementVNode("br"),
                          _createTextVNode("（免許証・保険証・パスポート・マイナンバーカード・学生証）"),
                          _createElementVNode("br"),
                          _createTextVNode(" 2.会員費の引落口座用のクレジットカード"),
                          _createElementVNode("br"),
                          _createTextVNode(" ※ご本人様名義、同姓の配偶者名義に限ります。 ")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_130, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.open2()))
              }, [
                _cache[131] || (_cache[131] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[132] || (_cache[132] = _createElementVNode("div", { class: "qa-list-title" }, "体験時の持ち物について教えてください。", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen2 ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, _cache[133] || (_cache[133] = [
                        _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1),
                        _createElementVNode("div", { class: "qa-list-text" }, [
                          _createTextVNode(" 1.動きやすい格好"),
                          _createElementVNode("br"),
                          _createTextVNode(" 2.汗拭きタオル"),
                          _createElementVNode("br"),
                          _createTextVNode(" 3.軍手"),
                          _createElementVNode("br"),
                          _createTextVNode(" 4.飲み物(水やスポーツドリンク)"),
                          _createElementVNode("br"),
                          _createTextVNode(" などをお持ちください。 ")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_132, [
              _createElementVNode("div", {
                class: "qa-list-item-child",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.open7()))
              }, [
                _cache[134] || (_cache[134] = _createElementVNode("div", { class: "qa-list-q text-gold" }, "Q", -1)),
                _cache[135] || (_cache[135] = _createElementVNode("div", { class: "qa-list-title" }, "クレジットカードが無く、現金払いでの支払いは可能ですか？", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-arrow-bottom", _ctx.state.isOpen7 ? 'active' : ''])
                }, null, 2)
              ]),
              _createVNode(_Transition, { name: "open" }, {
                default: _withCtx(() => [
                  (_ctx.state.isOpen7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, _cache[136] || (_cache[136] = [
                        _createElementVNode("div", { class: "qa-list-q text-gold" }, "A", -1),
                        _createElementVNode("div", { class: "qa-list-text" }, " 基本的にクレジットカードのみでのお支払いとさせていただいております。特例としてクレジットカードお持ちでない方限定で現金でのお支払いもお受けしております。キャンペーンでのご入会ご希望の場合、半年一括分の会費を入会時にお納めいだだきます。半年以降の会費お支払いは3ヶ月分ずつお支払いいただきます。キャンペーン非適応でのご入会適応の方は入会金11000円、顔認証登録手数料2200円、会費3ヶ月分お支払いいただきます。 ", -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_134, [
          _cache[140] || (_cache[140] = _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "Staff"),
            _createElementVNode("p", null, "スタッフ紹介")
          ], -1)),
          _createElementVNode("ul", _hoisted_135, [
            _createElementVNode("li", _hoisted_136, [
              _createVNode(_component_router_link, { to: "/NO1" }, {
                default: _withCtx(() => _cache[138] || (_cache[138] = [
                  _createElementVNode("div", { class: "memberMin" }, [
                    _createElementVNode("div", { class: "pic" }, [
                      _createElementVNode("img", { src: _imports_11 })
                    ]),
                    _createElementVNode("div", { class: "tmName" }, [
                      _createElementVNode("div", { class: "icon-arrow-left" }),
                      _createElementVNode("span", { class: "name" }, "KEISUKE MIYAMOTO"),
                      _createElementVNode("span", { class: "home" }, "宮元 啓介"),
                      _createElementVNode("span", { class: "kinds" }, "代表")
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_137, [
              _createElementVNode("div", {
                class: "memberMin",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onTapTrainerPop && _ctx.onTapTrainerPop(...args)))
              }, _cache[139] || (_cache[139] = [
                _createStaticVNode("<div class=\"pic\" data-v-42963e7e><img src=\"" + _imports_12 + "\" data-v-42963e7e></div><div class=\"tmName\" data-v-42963e7e><div class=\"icon-arrow-left\" data-v-42963e7e></div><span class=\"name\" data-v-42963e7e>TORA</span><span class=\"home\" data-v-42963e7e>トラ</span><span class=\"kinds\" data-v-42963e7e>トレーナー</span></div>", 2)
              ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_138, [
          _cache[142] || (_cache[142] = _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "Facilittes"),
            _createElementVNode("p", null, "施設紹介")
          ], -1)),
          _createElementVNode("div", _hoisted_139, [
            _createVNode(_component_Carousel, _mergeProps(_ctx.settings, {
              breakpoints: _ctx.breakpoints,
              autoplay: 3000,
              "wrap-around": true
            }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.slides3, (slide, idx) => {
                  return (_openBlock(), _createBlock(_component_Slide, { key: idx }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "pic",
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onTapFacilittes && _ctx.onTapFacilittes(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.state.slides3[idx].img
                        }, null, 8, _hoisted_140),
                        _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.state.slides3[idx].title), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 16, ["breakpoints"])
          ]),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, [
                _createVNode(_component_router_link, { to: "/Facilittes" }, {
                  default: _withCtx(() => _cache[141] || (_cache[141] = [
                    _createElementVNode("div", { class: "icon-arrow-left" }, null, -1),
                    _createTextVNode(" 詳しく見る ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _cache[147] || (_cache[147] = _createStaticVNode("<div id=\"info\" class=\"info fade-in\" data-v-42963e7e><div class=\"top-items-title\" data-v-42963e7e><h2 data-v-42963e7e>Info</h2><p data-v-42963e7e>ジム案内</p></div><ul class=\"info-list\" data-v-42963e7e><li class=\"info-list-item\" data-v-42963e7e><div class=\"info-list-title\" data-v-42963e7e>電話番号</div><div class=\"info-list-des\" data-v-42963e7e><a href=\"tel:0356729860\" data-v-42963e7e>03-5672-9860</a></div></li><li class=\"info-list-item\" data-v-42963e7e><div class=\"info-list-title\" data-v-42963e7e>FAX</div><div class=\"info-list-des\" data-v-42963e7e>03-5672-9860</div></li><li class=\"info-list-item\" data-v-42963e7e><div class=\"info-list-title\" data-v-42963e7e>メールアドレス</div><div class=\"info-list-des\" data-v-42963e7e><a href=\"mailto:cyclonegym.0301@gmail.com\" data-v-42963e7e>cyclonegym.0301@gmail.com</a></div></li><li class=\"info-list-item\" data-v-42963e7e><div class=\"info-list-title\" data-v-42963e7e>営業時間</div><div class=\"info-list-des\" data-v-42963e7e>月〜金10:00〜22:00 土曜日10:00〜20:00 日曜日12:00〜18:00<br data-v-42963e7e>休館日祝日</div></li><li class=\"info-list-item\" data-v-42963e7e><div class=\"info-list-title\" data-v-42963e7e>SNS</div><div class=\"info-list-des\" data-v-42963e7e><div class=\"waku\" data-v-42963e7e><div class=\"twitter\" data-v-42963e7e><a href=\"https://twitter.com/CYCLONEGYM11\" target=\"_blank\" data-v-42963e7e><img class=\"img_1\" src=\"" + _imports_13 + "\" data-v-42963e7e></a></div><div class=\"instagram\" data-v-42963e7e><a href=\"https://www.instagram.com/cyclone.gym/\" target=\"_blank\" data-v-42963e7e><img class=\"img_1\" src=\"" + _imports_14 + "\" data-v-42963e7e></a></div></div></div></li></ul><div class=\"info-bg\" data-v-42963e7e> I&#39;m Nicer<br data-v-42963e7e> After<br data-v-42963e7e> Kickboxing <img src=\"" + _imports_15 + "\" data-v-42963e7e></div></div>", 1)),
        _cache[148] || (_cache[148] = _createElementVNode("div", {
          id: "access",
          class: "access fade-in"
        }, [
          _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "Access"),
            _createElementVNode("p", null, "アクセス")
          ]),
          _createElementVNode("ul", { class: "access-list" }, [
            _createElementVNode("li", { class: "access-list-item" }, "東京都葛飾区金町6-4-4 クライスビル1F"),
            _createElementVNode("li", { class: "access-list-item" }, [
              _createTextVNode("・JR常磐線『金町駅』から徒歩3分"),
              _createElementVNode("br"),
              _createTextVNode(" ・京成金町線『京成金町駅』から徒歩6分")
            ]),
            _createElementVNode("li", { class: "access-list-item" }, [
              _createElementVNode("div", { class: "googlemap-bw" }, [
                _createElementVNode("iframe", {
                  src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.2449119631924!2d139.87153617612825!3d35.76935982512705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188574c08f86e9%3A0x5c38fd2e8ec37635!2z44CSMTI1LTAwNDIg5p2x5Lqs6YO96JGb6aO-5Yy66YeR55S677yW5LiB55uu77yU4oiS77yUIOOCr-ODqeOCpOOCueODk-ODqyAxZg!5e0!3m2!1sja!2sjp!4v1684163180166!5m2!1sja!2sjp",
                  style: {"border":"0"},
                  allowfullscreen: "",
                  loading: "lazy",
                  referrerpolicy: "no-referrer-when-downgrade"
                })
              ])
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_145, [
          _cache[144] || (_cache[144] = _createElementVNode("div", { class: "attention" }, [
            _createElementVNode("p", null, [
              _createTextVNode("体験、見学受付中"),
              _createElementVNode("br"),
              _createTextVNode("こちらから")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_146, [
            _createElementVNode("div", _hoisted_147, [
              _createVNode(_component_router_link, {
                to: "/Contact",
                onClick: _ctx.onTapReturnButton
              }, {
                default: _withCtx(() => _cache[143] || (_cache[143] = [
                  _createElementVNode("div", { class: "icon-arrow-left" }, null, -1),
                  _createTextVNode(" お問い合わせ ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}